export default __webpack_public_path__ + "static/media/Бор_20л-removebg-preview.c5d117e4.png";